<div class="add-certificate">
  <div class="modal-header">
    @if (mode === 'edit') {
      <div class="title">Replace Digital Certificate</div>
    }
    @if (mode === 'add') {
      <div class="title">Add Digital Certificate</div>
    }
  </div>
  <ng-container>
    <div class="modal-body">
      <form [formGroup]="uploadDigitalCertificate" class="clrsgn-form">
        <ng-container>
          <div class="form-group">
            <mat-label for="certificate" class="clrsgn-label">Upload New Digital Certificate:</mat-label>
            <app-file-upload id="digitalCertificateFileUpload" formControlName="certificate" accept=".pfx" (change)="onFileSelected($event)"></app-file-upload>
            <app-form-error [group]="uploadDigitalCertificate"
              [controlName]="'certificate'"
            [customErrorMessage]="'Please select a .PFX file'"></app-form-error>
          </div>
          @if (certificateUploaded | async) {
            <mat-form-field class="mt-2" appearance="fill">
              <mat-label for="password" class="clrsgn-label">
                Password:
              </mat-label>
              <input matInput
                maxlength="128"
                type="password"
                formControlName="password"
                id="name"
                (keydown.enter)="saveDigitalCertificate()">
              </mat-form-field>
            }
          </ng-container>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-secondary me-3" (click)="close()">Cancel</button>
        <button type="button" class="btn-primary" (click)="saveDigitalCertificate()">Save</button>
      </div>
    </ng-container>
  </div>
